import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        occurrence: '=',
        canManageOccurrences: '=',
        rooms: '=',
        trainers: '=',
        trainingCompanies: '=',
        training: '=',
        time: '=',
        uibModalInstance: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2 ng-if="vm.training.type==vm.COURSE_TRAINING_TYPE_ENUM.KEYS.CLASSROOM || vm.training.type==vm.COURSE_TRAINING_TYPE_ENUM.KEYS.WEBINAR">
                <span ng-if="vm.canManageOccurrences">{{ 'occurrence.Add/Edit training time' | translate }}</span>
                <span ng-if="!vm.canManageOccurrences">{{ 'occurrence.View training time' | translate }}</span>
            </h2>
            <h2 ng-if="vm.training.type==vm.COURSE_TRAINING_TYPE_ENUM.KEYS.TEST">
                <span ng-if="vm.canManageOccurrences">{{ 'occurrence.Add/Edit test time' | translate }}</span>
                <span ng-if="!vm.canManageOccurrences">{{ 'occurrence.View test time' | translate }}</span>
            </h2>
        </div>
        <div class="modal-body">
            <div class="form">
                <div class="row">
                    <label class="label">{{ 'occurrence.Training' | translate }}</label>
                    <div class="items">
                        <span class="text">{{ vm.training.name }}</span>
                    </div>
                </div>
                <form-row error="vm.timeCopy.errors.courseIsArchived">
                    <div class="items">
                       <form-row-error></form-row-error>
                    </div>
                </form-row>
                <div ng-if="vm.training.type==vm.COURSE_TRAINING_TYPE_ENUM.KEYS.CLASSROOM || vm.training.type==vm.COURSE_TRAINING_TYPE_ENUM.KEYS.WEBINAR">
                    <form-row error="vm.timeCopy.errors.timeStart || vm.timeCopy.errors.timeEnd">
                        <span class="label">{{ 'occurrence.Training time' | translate }}</span>
                        <div class="items">
                            <div class="clear">
                                <datetimepicker ng-model="vm.timeCopy.timeStart" ng-disabled="vm.disableEditing"></datetimepicker>
                                <p class="desc">{{ 'occurrence.From' | translate }}</p>
                            </div>
                            <div class="clear">
                                <datetimepicker ng-model="vm.timeCopy.timeEnd" ng-disabled="vm.disableEditing"></datetimepicker>
                                <p class="desc">{{ 'occurrence.To' | translate }}</p>
                            </div>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.timeCopy.errors.hasCapacity" ng-if="!vm.isNewRoom">
                        <label class="label">{{ 'occurrence.Limit participants' | translate }}</label>
                        <div class="items">
                            <ul class="checkboxes">
                                <li>
                                    <input type="checkbox" ng-model="vm.timeCopy.hasCapacity" ng-disabled="vm.disableEditing">
                                </li>
                            </ul>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.timeCopy.errors.capacity" ng-if="!vm.isNewRoom && vm.timeCopy.hasCapacity">
                        <label class="label"></label>
                        <div class="items">
                             <input ng-model="vm.timeCopy.capacity"
                                    type="number"
                                    min="1"
                                    class="form-control small"
                                    ng-disabled="vm.disableEditing"
                             >
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                </div>
                <div ng-if="vm.training.type==vm.COURSE_TRAINING_TYPE_ENUM.KEYS.TEST">
                    <form-row error="vm.timeCopy.errors.timeStart">
                        <span class="label">{{ 'occurrence.Accessible from' | translate }}</span>
                        <div class="items">
                            <datetimepicker ng-model="vm.timeCopy.timeStart" default-time="'00:00'" ng-disabled="vm.disableEditing"></datetimepicker>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.timeCopy.errors.timeEnd">
                        <label class="label">{{ 'occurrence.Deadline' | translate }}</label>
                        <div class="items">
                            <datetimepicker ng-model="vm.timeCopy.timeEnd" default-time="'23:59'" ng-disabled="vm.disableEditing"></datetimepicker>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.timeCopy.errors.hasCapacity" ng-if="!vm.isNewRoom">
                        <label class="label">{{ 'occurrence.Limit participants' | translate }}</label>
                        <div class="items">
                            <ul class="checkboxes">
                                <li>
                                    <input type="checkbox" ng-model="vm.timeCopy.hasCapacity" ng-disabled="vm.disableEditing">
                                </li>
                            </ul>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.timeCopy.errors.capacity" ng-if="!vm.isNewRoom && vm.timeCopy.hasCapacity">
                        <label class="label"></label>
                        <div class="items">
                             <input ng-model="vm.timeCopy.capacity"
                                    type="number"
                                    min="1"
                                    class="form-control small"
                                    ng-disabled="vm.disableEditing"
                             >
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                </div>
                <div ng-if="vm.training.type==vm.COURSE_TRAINING_TYPE_ENUM.KEYS.WEBINAR">
                    <form-row error="vm.timeCopy.errors.webinarUrl">
                        <span class="label">{{ 'occurrence.Webinar url' | translate }} *</span>
                        <div class="items">
                            <input ng-model="vm.timeCopy.webinarUrl" class="form-control" ng-disabled="vm.disableEditing">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.timeCopy.errors.webinarTitle">
                        <label class="label">{{ 'occurrence.Webinar title' | translate }} *</label>
                        <div class="items">
                            <input ng-model="vm.timeCopy.webinarTitle" class="form-control" ng-disabled="vm.disableEditing">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                </div>
                <modals-courses-occurrence-manage-training-time-room ng-if="vm.training.type!=vm.COURSE_TRAINING_TYPE_ENUM.KEYS.WEBINAR"
                    rooms="vm.rooms"
                    time-copy="vm.timeCopy"
                    room-form="vm.roomForm"
                    disable-editing="vm.disableEditing"
                    is-new-room="vm.isNewRoom"
                    cancel-new-room="vm.cancelNewRoom()" />
                <form-row error="vm.timeCopy.errors.trainerIds">
                    <label class="label">{{ 'occurrence.Trainer' | translate }}</label>
                    <div class="items">
                        <tags-input
                            ng-disabled="!vm.canManageOccurrences"
                            ng-model="vm.timeCopy.trainers"
                            display-property="displayName"
                            key-property="id"
                            add-from-autocomplete-only="true"
                            replace-spaces-with-dashes="false"
                            on-tag-removed="vm.$scope.$emit('trainer:remove', $tag.id)"
                            placeholder="{{ 'occurrence.Find a trainer' | translate }}"
                            >
                            <auto-complete min-length="1" source="vm.filterTrainers($query)"></auto-complete>
                        </tags-input>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row error="vm.timeCopy.errors.trainingCompanyIds">
                    <label class="label">{{ 'occurrence.Training company' | translate }}</label>
                    <div class="items">
                        <tags-input
                            ng-disabled="!vm.canManageOccurrences"
                            ng-model="vm.timeCopy.trainingCompanies"
                            display-property="name"
                            add-from-autocomplete-only="true"
                            replace-spaces-with-dashes="false"
                            on-tag-removed="vm.removeTrainingCompanyTrainer()"
                            placeholder="{{ 'occurrence.Find a company' | translate }}">
                            <auto-complete min-length="1" source="vm.filterTrainingCompanies($query)"></auto-complete>
                        </tags-input>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row ng-if="vm.timeCopy.trainingCompanies.length" error="vm.timeCopy.errors.trainingCompanyTrainer">
                    <label class="label">{{ 'occurrence.External trainer' | translate }}</label>
                    <div class="items">
                        <input
                            ng-disabled="!vm.canManageOccurrences"
                            ng-model="vm.timeCopy.trainingCompanyTrainer"
                            type="text"
                            class="form-control">
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary" ng-if="vm.canManageOccurrences">
                    <button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button>
                </li>
                <li ng-if="vm.time && !vm.disableEditing">
                    <button class="btn bordered02" type="button" ng-click="vm.delete()">{{ 'general.Delete' | translate }}</button>
                </li>
                <li><button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()">{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    `
})

export default class {
    constructor ($translate, $scope, lodash, moment, FormFactory, OccurrenceResource, RoomResource, ModalService, MomentService,
                 OccurrenceTrainingService, OccurrenceService, OCCURRENCE_STATUS_ENUM,
                 COURSE_TRAINING_TYPE_ENUM, COURSE_TRAINING_ORDER_TYPE_ENUM) {
        this.$translate = $translate;
        this.$scope = $scope;
        this.lodash = lodash;
        this.moment = moment;
        this.OccurrenceResource = OccurrenceResource;
        this.ModalService = ModalService;
        this.MomentService = MomentService;
        this.OccurrenceTrainingService = OccurrenceTrainingService;
        this.OccurrenceService = OccurrenceService;
        this.OCCURRENCE_STATUS_ENUM = OCCURRENCE_STATUS_ENUM;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
        this.COURSE_TRAINING_ORDER_TYPE_ENUM = COURSE_TRAINING_ORDER_TYPE_ENUM;
        this.RoomResource = RoomResource;
        this.roomForm = FormFactory.create(new RoomResource(), model => model.$save());
    }

    $onInit () {
        this.isTrainingOrderSequence = this.occurrence.courseVersion.trainingOrderType === this.COURSE_TRAINING_ORDER_TYPE_ENUM.KEYS.SEQUENCE;
        this.initTraining();
        this.initTime();

        this.timeIndex = 0;
        if (this.trainingCopy.times !== undefined) {
            this.timeIndex = this.trainingCopy.times.length;
        }

        if (this.time !== undefined) {
            this.timeIndex = this.lodash.findIndex(this.trainingCopy.times, { id: this.time.id });
        }

        this.isNewRoom = false;
    }

    initTraining () {
        // use copy to avoid invalid data display on background of modal
        this.trainingCopy = angular.copy(this.training);
        if (this.trainingCopy.times === null) {
            this.trainingCopy.times = [];
        }
    }

    initTime () {
        this.timeCopy = {
            id: undefined,
            timeStart: undefined,
            timeEnd: undefined,
            roomId: undefined,
            trainers: [], // for autocomplete
            trainingCompanies: [], // for autocomplete
            trainerIds: [],
            participantIds: [],
            isReportConfirmed: 0
        };

        if (this.time !== undefined) {
            // use copy to avoid invalid data display on background of modal
            this.timeCopy = angular.copy(this.time);
            this.timeCopy.trainers = this.timeCopy.trainerIds.map((id) => (this.lodash.find(this.trainers, { id: parseInt(id, 10) })));
            this.timeCopy.trainingCompanies = this.timeCopy.trainingCompanyIds.map((id) => (this.lodash.find(this.trainingCompanies, { id: parseInt(id, 10) })));
        }
        this.hasParticipants = this.timeCopy.participantIds.length > 0;
        this.disableEditing = !this.canManageOccurrences || this.timeCopy.isReportConfirmed;
    }

    filterTrainers (value) {
        return this.trainers.filter((trainer) => this.lodash.includes(trainer.displayName.toUpperCase(), value.toUpperCase()));
    }

    filterTrainingCompanies (value) {
        return this.trainingCompanies.filter((company) => this.lodash.includes(company.name.toUpperCase(), value.toUpperCase()));
    }

    cancelNewRoom () {
        this.isNewRoom = false;
        this.roomForm.model.name = null;
        this.roomForm.model.capacity = null;
    }

    beforeSave () {
        this.timeCopy.trainingId = this.trainingCopy.trainingId;
        this.timeCopy.trainingType = this.trainingCopy.type;
        this.timeCopy.trainerIds = this.timeCopy.trainers.map((val) => (val.id));
        this.timeCopy.trainingCompanyIds = this.timeCopy.trainingCompanies.map((val) => (val.id));

        // we overwrite the times array, because we want to validate/save only this training time
        this.trainingCopy.times = [this.timeCopy];

        // turn off feedback deadline validating in modal
        this.trainingCopy.validateFeedbackDeadline = false;
    }

    setTrainings (deleteObsoleteTimes) {
        this.OccurrenceResource.setTrainings({ id: this.occurrence.id, deleteObsoleteTimes }, [this.trainingCopy]).$promise
            .then((trainings) => {
                // close modal and pass updated training, note that setTrainings returns an array
                this.uibModalInstance.close(trainings[0]);
            })
            .catch((errors) => {
                this.timeCopy.errors = {};
                this.lodash.forEach(errors.data, (error) => {
                    this.lodash.set(this.timeCopy, `errors.${error.field}`, error.message);
                });
            });
    }

    save () {
        this.beforeSave();

        if (this.isNewRoom) {
            this.roomForm.save().then(model => {
                this.timeCopy.roomId = model.id;
                this.continueSave();
            });
        }
        else {
            this.continueSave();
        }
    }

    continueSave () {
        this.OccurrenceResource.setTrainings({ id: this.occurrence.id, validateOnly: true }, [this.trainingCopy]).$promise
            .then(() => {
                if (!this.OccurrenceService.isPublished(this.occurrence)) {
                    this.doSave();
                }
                else {
                    this.savePublished();
                }
            })
            .catch((errors) => {
                this.RoomResource.query().$promise.then(rooms => {
                    // in case training time was saved with new room
                    this.rooms = rooms;
                    this.isNewRoom = false;
                });
                this.timeCopy.errors = {};
                this.lodash.forEach(errors.data, (error) => {
                    this.lodash.set(this.timeCopy, `errors.${error.field}`, error.message);

                    // feedback_deadline field is outside of training time modal,
                    // but validation is made against time_end field
                    if (this.timeCopy.errors.feedbackDeadline) {
                        this.timeCopy.errors.timeEnd = this.timeCopy.errors.feedbackDeadline;
                    }
                });
            });
    }

    isTrainingTimeEdited () {
        const { time, timeCopy } = this;
        return time.roomId !== timeCopy.roomId
            || time.timeStart !== timeCopy.timeStart
            || time.timeEnd !== timeCopy.timeEnd
            || time.webinarTitle !== timeCopy.webinarTitle
            || time.webinarUrl !== timeCopy.webinarUrl
            || time.trainingCompanyIds.sort().toString() !== timeCopy.trainingCompanyIds.sort().toString()
            || time.trainerIds.sort().toString() !== timeCopy.trainerIds.sort().toString()
        ;
    }

    savePublished () {
        const participantsConfirmMessage = this.$translate.instant('occurrence.published.confirmation_message.time_has_participants');
        // ask confirmation if training time has participants and time start, time end or room changes
        const showParticipantConfirm = this.hasParticipants && this.isTrainingTimeEdited();
        if (this.isTrainingOrderSequence) {
            // ask confirmation if editing existing time
            if (this.timeCopy.id) {
                const editConfirmMessage = this.$translate.instant('occurrence.published.confirmation_message.time_edit');
                this.ModalService.confirm(editConfirmMessage, 'medium').then(() => {
                    if (showParticipantConfirm) {
                        this.ModalService.confirm(participantsConfirmMessage, 'medium').then(() => this.doSave());
                    }
                    else {
                        this.doSave();
                    }
                });
            }
            else {
                const addConfirmMessage = this.$translate.instant('occurrence.published.confirmation_message.time_add');
                this.ModalService.confirm(addConfirmMessage, 'medium').then(() => this.doSave());
            }
        }
        else {
            if (showParticipantConfirm) {
                this.ModalService.confirm(participantsConfirmMessage, 'medium').then(() => this.doSave());
            }
            else {
                this.doSave();
            }
        }
    }

    doSave () {
        const roomRequiredMessage = this.$translate.instant('occurrence.A room has not been selected for the test. Are you sure you want to save changes?');
        if (!this.training.isRoomRequired && !this.timeCopy.roomId) {
            this.ModalService.confirm(roomRequiredMessage, 'medium').then(() => {
                this.setTrainings(false);
            });
        }
        else {
            this.setTrainings(false);
        }
    }

    delete () {
        if (this.OccurrenceService.isPublished(this.occurrence) && this.hasParticipants) {
            const deleteConfirmMessage = this.$translate.instant('occurrence.published.confirmation_message.time_delete');
            this.ModalService.delete(deleteConfirmMessage).then(() => {
                this.trainingCopy.times.splice(this.timeIndex, 1);
                this.setTrainings(true);
            });
        }
        else {
            this.ModalService.delete().then(() => {
                this.trainingCopy.times.splice(this.timeIndex, 1);
                this.setTrainings(true);
            });
        }
    }

    removeTrainingCompanyTrainer () {
        if (!this.timeCopy.trainingCompanies.length) {
            this.timeCopy.trainingCompanyTrainer = null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/occurrence/manageTrainingTime/index.js